import { chakra, Tab as ChakraTab } from '@chakra-ui/react';

export const Tab = chakra(ChakraTab, {
  baseStyle: {
    transition: 'border-bottom 0.2s',
  },
});
